import axios from 'axios';

import Device from 'types/models/device';
import Enterprise from 'types/models/enterprise';
import Site from 'types/models/site';
import { APIResponseParsed } from 'types/response';
import { getRequest } from 'utils/HttpRequest/http-request-utils';

import { parseAxiosError } from './utils/parse-axios-error';

// ==============================
// TYPES
// ==============================
export type DeviceWithRelations = Device & {
  enterprise?: Enterprise;
  site?: Site;
};

export type FetchBackOfficeDevicesParams = {
  per_page?: number;
  page?: number;
  sort?: string[];
  s?: {
    serialNumber?: { $eq: string };
  };
};

export type PaginatedDevicesResponse = {
  total: number;
  data: DeviceWithRelations[];
};

// ==============================
// REQUESTS
// ==============================
async function fetchDevices(
  params: FetchBackOfficeDevicesParams
): Promise<APIResponseParsed<PaginatedDevicesResponse>> {
  try {
    const response = await getRequest<PaginatedDevicesResponse>(
      '/device?join=site&join=enterprise',
      { params }
    );
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

async function fetchOneDeviceBySerialNumber(
  searchText: string
): Promise<APIResponseParsed<DeviceWithRelations | null>> {
  const response = await fetchDevices({
    per_page: 1,
    page: 1,
    s: {
      serialNumber: { $eq: searchText }
    }
  });

  if (response.error) {
    return { data: null, error: response.error };
  }

  const device = response.data?.data[0] ?? null;
  return { data: device, error: null };
}

export default {
  fetchDevices,
  fetchOneDeviceBySerialNumber
};
